import shortid from 'shortid'

export const initialState = {
  wizards: {},
  activeCategory: '',
  categoriesOrder: {},
  categories: null,
  categoryIcons: {},
  loading: true,
  dragging: null,
  isOver: null,
  wasOver: null,
  saving: null,
  importDialogOpen: false,
  filter: '',
}

const managerReducer = (state = initialState, action) => {
  switch (action.type) {
    case '@@fm/RESET_STATE':
      return initialState
    case '@@fm/POPULATE_STRUCTURE':
      return { ...state, ...action.payload, isOver: null, wasOver: null, saving: null }
    case '@@fm/SET_ALL_WIZARDS':
      return {
        ...state,
        wizards: { ...state.wizards, [action.category]: action.wizards },
        activeCategory: action.category,
      }
    case '@@fm/TOGGLE_LOADING':
      return { ...state, loading: state.loading !== false ? action.loading : false }
    case '@@fm/SET_FILTER':
      return { ...state, filter: action.filter }
    case '@@fm/SET_ACTIVE_CATEGORY':
      return { ...state, activeCategory: action.category }
    case '@@fm/ADD_CATEGORY': {
      let id = shortid.generate()
      const currentCategoriesOrder = state.categoriesOrder[state.activeCategory] || {}
      return {
        ...state,
        categoriesOrder: {
          ...state.categoriesOrder,
          [state.activeCategory]: [...currentCategoriesOrder, id],
        },
        categories: {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [id]: {
              title: 'New Category',
              wizardsOrder: [],
              visible: true,
              abbreviation: '',
            },
          },
        },
      }
    }
    case '@@fm/DELETE_CATEGORY': {
      const { [action.categoryId]: toDelete, ...category } = state.categories[state.activeCategory]
      return {
        ...state,
        categories: {
          ...state.categories,
          [state.activeCategory]: category,
        },
        categoriesOrder: {
          ...state.categoriesOrder,
          [state.activeCategory]: [
            ...state.categoriesOrder[state.activeCategory].slice(0, action.categoryIndex),
            ...state.categoriesOrder[state.activeCategory].slice(action.categoryIndex + 1),
          ],
        },
      }
    }
    case '@@fm/SET_ICON':
      return {
        ...state,
        categoryIcons: { ...state.categoryIcons, [state.activeCategory]: action.icon },
      }
    case '@@fm/TOGGLE_DRAGGING':
      return { ...state, dragging: action.dragging }
    case '@@fm/TOGGLE_SAVING':
      return { ...state, saving: action.saving }
    case '@@fm/TOGGLE_IMPORT_DIALOG':
      return { ...state, importDialogOpen: action.isOpen }
    case '@@fm/SET_ISOVER':
      return { ...state, isOver: action.isOver, wasOver: state.isOver }
    case '@@fm/SET_WASOVER':
      return { ...state, wasOver: action.wasOver }
    case '@@fm/SET_CATEGORY_TITLE':
      return {
        ...state,
        categories: {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.categoryId]: {
              ...state.categories[state.activeCategory][action.categoryId],
              title: action.title,
            },
          },
        },
      }
    case '@@fm/SET_CATEGORY_ABBREVIATION':
      return {
        ...state,
        categories: {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.categoryId]: {
              ...state.categories[state.activeCategory][action.categoryId],
              abbreviation: action.abbreviation,
            },
          },
        },
      }
    case '@@fm/TOGGLE_VISIBILITY':
      return {
        ...state,
        categories: {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.categoryId]: {
              ...state.categories[state.activeCategory][action.categoryId],
              visible: action.on,
            },
          },
        },
      }
    case '@@fm/MOVE_WIZARD': {
      let originWizardsOrder =
        state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder
      let targetWizardsOrder =
        state.categories[state.activeCategory][action.target.categoryId].wizardsOrder
      let originWizardIndex = originWizardsOrder.findIndex(
        (id) => action.origin.formDefinitionId === id
      )
      let targetWizardIndex = targetWizardsOrder.findIndex(
        (id) => action.target.formDefinitionId === id
      )
      let newOriginWizardsOrder, newTargetWizardsOrder, categories
      if (action.origin.categoryId !== action.target.categoryId) {
        newOriginWizardsOrder = [
          ...originWizardsOrder.slice(0, originWizardIndex),
          ...originWizardsOrder.slice(originWizardIndex + 1),
        ]
        newTargetWizardsOrder = [
          ...targetWizardsOrder.slice(0, targetWizardIndex),
          action.origin.formDefinitionId,
          ...targetWizardsOrder.slice(targetWizardIndex),
        ]
        categories = {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.origin.categoryId]: {
              ...state.categories[state.activeCategory][action.origin.categoryId],
              wizardsOrder: newOriginWizardsOrder,
            },
            [action.target.categoryId]: {
              ...state.categories[state.activeCategory][action.target.categoryId],
              wizardsOrder: newTargetWizardsOrder,
            },
          },
        }
      } else {
        newTargetWizardsOrder = [
          ...targetWizardsOrder.slice(0, originWizardIndex),
          ...targetWizardsOrder.slice(originWizardIndex + 1),
        ]
        newTargetWizardsOrder = [
          ...newTargetWizardsOrder.slice(
            0,
            targetWizardIndex + (originWizardIndex > targetWizardIndex ? 0 : -1)
          ),
          action.origin.formDefinitionId,
          ...newTargetWizardsOrder.slice(
            targetWizardIndex + (originWizardIndex > targetWizardIndex ? 0 : -1)
          ),
        ]
        categories = {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.target.categoryId]: {
              ...state.categories[state.activeCategory][action.target.categoryId],
              wizardsOrder: newTargetWizardsOrder,
            },
          },
        }
      }
      return {
        ...state,
        categories,
      }
    }
    case '@@fm/MOVE_WIZARD_TO_EMPTY_CATEGORY': {
      let originWizardsOrder =
        state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder
      let originWizardIndex = originWizardsOrder.findIndex(
        (id) => action.origin.formDefinitionId === id
      )
      let originCategory = [
        ...state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder.slice(
          0,
          originWizardIndex
        ),
        ...state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder.slice(
          originWizardIndex + 1
        ),
      ]
      return {
        ...state,
        categories: {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.origin.categoryId]: {
              ...state.categories[state.activeCategory][action.origin.categoryId],
              wizardsOrder: originCategory,
            },
            [action.target]: {
              ...state.categories[state.activeCategory][action.target],
              wizardsOrder: [action.origin.formDefinitionId],
            },
          },
        },
      }
    }
    case '@@fm/REORDER_CATEGORY': {
      let categoriesOrder
      if (action.direction === 'up') {
        categoriesOrder = [
          ...state.categoriesOrder[state.activeCategory].slice(0, action.categoryIndex - 1),
          action.categoryId,
          state.categoriesOrder[state.activeCategory][action.categoryIndex - 1],
          ...state.categoriesOrder[state.activeCategory].slice(action.categoryIndex + 1),
        ]
      } else {
        categoriesOrder = [
          ...state.categoriesOrder[state.activeCategory].slice(0, action.categoryIndex),
          state.categoriesOrder[state.activeCategory][action.categoryIndex + 1],
          action.categoryId,
          ...state.categoriesOrder[state.activeCategory].slice(action.categoryIndex + 2),
        ]
      }
      return {
        ...state,
        categoriesOrder: {
          ...state.categoriesOrder,
          [state.activeCategory]: categoriesOrder,
        },
      }
    }
    case '@@fm/MOVE_WIZARD_TO_LAST': {
      let originWizardsOrder =
        state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder
      let originWizardIndex = originWizardsOrder.findIndex(
        (id) => action.origin.formDefinitionId === id
      )
      let categories
      if (action.origin.categoryId !== action.target) {
        categories = {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.origin.categoryId]: {
              ...state.categories[state.activeCategory][action.origin.categoryId],
              wizardsOrder: [
                ...state.categories[state.activeCategory][
                  action.origin.categoryId
                ].wizardsOrder.slice(0, originWizardIndex),
                ...state.categories[state.activeCategory][
                  action.origin.categoryId
                ].wizardsOrder.slice(originWizardIndex + 1),
              ],
            },
            [action.target]: {
              ...state.categories[state.activeCategory][action.target],
              wizardsOrder: [
                ...state.categories[state.activeCategory][action.target].wizardsOrder,
                action.origin.formDefinitionId,
              ],
            },
          },
        }
      } else {
        let newOriginWizardsOrder = [
          ...originWizardsOrder.slice(0, originWizardIndex),
          ...originWizardsOrder.slice(originWizardIndex + 1),
        ]
        categories = {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.origin.categoryId]: {
              ...state.categories[state.activeCategory][action.origin.categoryId],
              wizardsOrder: [...newOriginWizardsOrder, action.origin.formDefinitionId],
            },
          },
        }
      }
      return {
        ...state,
        categories,
      }
    }
    case '@@fm/PUBLISH_WIZARD': {
      let originformDefinitionId = action.origin.formDefinitionId
      let targetWizardIndex = state.categories[state.activeCategory][
        action.target.categoryId
      ].wizardsOrder.findIndex((id) => action.target.formDefinitionId === id)
      return {
        ...state,
        categories: {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.target.categoryId]: {
              ...state.categories[state.activeCategory][action.target.categoryId],
              wizardsOrder: [
                ...state.categories[state.activeCategory][
                  action.target.categoryId
                ].wizardsOrder.slice(0, targetWizardIndex),
                originformDefinitionId,
                ...state.categories[state.activeCategory][
                  action.target.categoryId
                ].wizardsOrder.slice(targetWizardIndex),
              ],
            },
          },
        },
      }
    }
    case '@@fm/PUBLISH_WIZARD_TO_LAST':
      return {
        ...state,
        categories: {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.target]: {
              ...state.categories[state.activeCategory][action.target],
              wizardsOrder: [
                ...state.categories[state.activeCategory][action.target].wizardsOrder,
                action.origin.formDefinitionId,
              ],
            },
          },
        },
      }
    case '@@fm/PUBLISH_WIZARD_TO_EMPTY_CATEGORY':
      return {
        ...state,
        categories: {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.target]: {
              ...state.categories[state.activeCategory][action.target],
              wizardsOrder: [action.origin.formDefinitionId],
            },
          },
        },
      }
    case '@@fm/UNPUBLISH_WIZARD': {
      let originWizardIndex = state.categories[state.activeCategory][
        action.origin.categoryId
      ].wizardsOrder.findIndex((id) => action.origin.formDefinitionId === id)
      return {
        ...state,
        categories: {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.origin.categoryId]: {
              ...state.categories[state.activeCategory][action.origin.categoryId],
              wizardsOrder: [
                ...state.categories[state.activeCategory][
                  action.origin.categoryId
                ].wizardsOrder.slice(0, originWizardIndex),
                ...state.categories[state.activeCategory][
                  action.origin.categoryId
                ].wizardsOrder.slice(originWizardIndex + 1),
              ],
            },
          },
        },
      }
    }
    case '@@fm/IMPORT_TO_LAST': {
      return {
        ...state,
        categories: {
          ...state.categories,
          [state.activeCategory]: {
            ...state.categories[state.activeCategory],
            [action.categoryId]: {
              ...state.categories[state.activeCategory][action.categoryId],
              wizardsOrder: [
                ...state.categories[state.activeCategory][action.categoryId].wizardsOrder,
                action.formDefinitionId,
              ],
            },
          },
        },
      }
    }
    default:
      return state
  }
}

export default managerReducer
